module.exports = new __parcel__URL__("favicon.8e0359a2.png").toString();